<template>
  <div>
    <div class="form-group">
      <div
        class="custom-control custom-checkbox"
        v-for="item in visibleItems"
        :key="item.id"
      >
        <input
          type="checkbox"
          :value="item.id"
          class="custom-control-input"
          :id="prefix + item.prefix + '-' + item.id"
          v-model.number="selectedTypes"
          v-on:click="setLastItem(item)"
        />
        <label class="custom-control-label" :for="prefix + item.prefix + '-' + item.id">{{
          item.name
        }}</label>
        <button
          class="btn btn-link"
          type="button"
          v-if="Object.keys(item.children).length > 0"
          v-on:click="toggle(item)"
          aria-haspopup="true"
          :aria-expanded="item.expanded ? 'true' : 'false'"
          :aria-label="item.name"
        >
          <font-awesome-icon
            :icon="['far', !item.expanded ? 'chevron-down' : 'chevron-up']"
          ></font-awesome-icon>
        </button>
        <tree-picker
          v-show="item.expanded"
          :tree="item.children"
          :prefix="prefix + item.prefix + '-' + item.id"
        ></tree-picker>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChevronDown as faChevronDownRegular,
  faChevronUp as faChevronUpRegular
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faChevronUpRegular, faChevronDownRegular);

export default {
  name: "TreePicker",

  props: {
    tree: {
      type: Object,
      required: true
    },
    prefix: {
      type: String,
      default: "tree"
    },
  },
  data: function() {
    return {
      lastItem: null
    };
  },
  computed: {
    visibleItems: function() {
      let visible = {};
      let i = 0;
      Object.keys(this.tree).map((objectKey, index) => {
        let item = this.tree[objectKey];
        let add = true;
        if (item.parent_id === 1) {
          if (this.$store.state.selected.cycles.length === 1) {
            add = item.id == parseInt(this.$store.state.selected.cycles[0]) + 9;
          } else {
            add = item.id == 12;
          }
          if (add) {
            Object.keys(item.children).map((childKey, childIndex) => {
              visible[i] = item.children[childKey];
              visible[i].prefix = '-' + item.id;
              i++;
            });
          }
        } else {
          visible[i] = item;
          visible[i].prefix = '';
          i++;
        }
      });
      return visible;
    },
    selectedTypes: {
      get() {
        return this.$store.state.selected.types;
      },
      set(value) {
        let path = null;
        if (!!this.lastItem && !!this.lastItem.prefix) {
          path = (this.prefix + this.lastItem.prefix).split("-");
          path.splice(0, 1);
        }

        this.$store.commit("updateSelected", {
          field: "types",
          value: value,
          path: path,
         // item: this.lastItem
        });
      }
    }
  },
  methods: {
    toggle: function(item) {
      if (!item.expanded) {
        this.$set(item, "expanded", true);
      } else {
        this.$set(item, "expanded", false);
      }
    },
    setLastItem: function(item) {
      this.lastItem = item;
    }
  },
  components: {
    FontAwesomeIcon
  }
};
</script>